import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { formatNisAmount } from '../../utils/labData';

/**
 * Spend breakdown by supplier; row navigates to orders list.
 */
const SpendBySupplierTable = ({ suppliers = [], dateFrom, dateTo }) => {
  const navigate = useNavigate();

  const handleRowClick = row => {
    if (!row?.supplier_id) return;
    const params = new URLSearchParams();
    if (dateFrom) params.set('from', dateFrom);
    if (dateTo) params.set('to', dateTo);
    params.set('supplier_id', String(row.supplier_id));
    navigate(`/orders?${params.toString()}`);
  };

  return (
    <Card variant="outlined" className="lab-data-table-card">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Spend by supplier
        </Typography>
        {!suppliers?.length ? (
          <Typography color="text.secondary">No supplier spend in this period.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Supplier</TableCell>
                <TableCell align="right">Spend</TableCell>
                <TableCell align="right">Orders</TableCell>
                <TableCell align="right">Lines</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {suppliers.map(row => (
                <TableRow
                  key={row.supplier_id ?? row.supplier_name}
                  hover
                  className={row.supplier_id ? 'lab-data-row-clickable' : ''}
                  onClick={() => handleRowClick(row)}
                >
                  <TableCell>{row.supplier_name ?? row.name ?? '—'}</TableCell>
                  <TableCell align="right">
                    {formatNisAmount(row.total_nis ?? row.spend_nis)}
                  </TableCell>
                  <TableCell align="right">{row.order_count ?? '—'}</TableCell>
                  <TableCell align="right">{row.line_count ?? '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default SpendBySupplierTable;
